<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card card-chart">
          <div class="card-header">
            <div class="row">
              <div class="col-md-12 text-left">
                <h2 class="card-title">STATISTIQUES CA ANNONCEUR/EDITEUR/TM/PARRAINEUR</h2>
              </div>
              <div class="col-md-12">
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12">
                      <base-radio inline name="af" class="mb-3" v-model="law">
                        EDITEURS
                      </base-radio>
                      <base-radio inline name="ma" class="mb-3" v-model="law">
                        TM
                      </base-radio>
                      <base-radio inline name="an" class="mb-3" v-model="law" disabled>
                        ANNONCEURS
                      </base-radio>
                      <base-radio inline name="pa" class="mb-3" v-model="law" v-if="email == 'n.khallouki@weedoit.fr' || email == 'a.gorani@weedoit.fr' || email == 'a.mouharir@weedoit.fr' || email == 's.boukbir@weedoit.fr' || email == 'k.ghalem@weedoit.fr'">
                        PARRAINEURS
                      </base-radio>
                  </div>
                  <div class="col-md-12 float">
                    <base-input v-if="law === 'pa'"
                        class="col-md-3 float-left"
                        placeholder="RECHERCHER PAR LOGIN"
                        v-model="societySelected"
                        :key="'search-pa'"
                        clearable
                    >
                    </base-input>
                    <base-input class="col-md-3 float-left" v-else>
                      <el-select filterable class="select-primary"
                        clearable
                        placeholder="NOM SOCIÉTÉ"
                        v-model="societySelected"
                        >
                        <el-option
                          v-for="option in ListClient"
                          class="select-primary"
                          :value="option.societe_client"
                          :label="(option.societe_client.length > 15 ) ? option.societe_client.slice(0,15).toUpperCase()+'...' : option.societe_client.toUpperCase()"
                          :key="option.societe_client">
                        </el-option>
                      </el-select>
                    </base-input>
                    <div class="btn-group btn-group-toggle float-right" data-toggle="buttons">
                      <base-button v-if="$apollo.queries.getTopCaAnnonceurOrEditeur.loading || downloadingParrains"
                        loading
                        class="btn btn-round btn-just-icon btn-default mt-0 d-block"
                        >{{ $t("buttons.BtnLoad").toUpperCase() }}...</base-button>
                      <base-button
                        class="btn btn-round btn-just-icon btn-primary"
                        v-else
                        @click="send"
                        >{{ $t("buttons.BtnSearch").toUpperCase() }}</base-button>
                    </div>
                    <div class="col-12 float-left">
                      <button class="btn btn-round btn-info float-right" @click="ExportTable()">
                        <i class="tim-icons icon-cloud-download-93"></i> EXPORT
                      </button>
                      <button class="btn btn-round btn-warning float-right mr-2 d-flex align-items-center" @click="openLeadValuesModal()" v-if="law === 'pa'">
                      <i class="tim-icons icon-settings-gear-63 mr-1 text-uppercase"></i>
                      Configuration points
                    </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card card-chart">
          <div class="p-2" data="black">
            <div class="row" v-if="law === 'pa'">
                <div class="col-4">
                    <base-input>
                    <el-select
                        class="select-primary pagination-select"
                        v-model="paginationPa.perPage"
                        placeholder="Per page"
                    >
                        <el-option
                        class="select-primary"
                        v-for="item in paginationPa.perPageOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                        ></el-option>
                    </el-select>
                    </base-input>
                </div>
            </div>
            <!-- ================================================================ -->
            <!-- TABLEAU 1 : AFFICHAGE POUR PARRAINEURS (law === 'pa')              -->
            <!-- ================================================================ -->
            <el-table :key="'table-pa'" v-if="law === 'pa'" :data="queriedData" show-summary :summary-method="getPaSummaries" v-loading="(updatingPoints || downloadingParrains) && !ShowLeadValuesModal" class="customtable_cmd">
                <!-- Colonne Expand -->
                <el-table-column type="expand" :key="'expand-col-pa'">
                    <template slot-scope="props">
                        <div class="p-1" style="margin-left: 50px;">
                            <div class="row">
                                <!-- TABLEAU DES LEADS -->
                                <div class="col-md-6" v-if="props.row.leads_detail && Object.keys(props.row.leads_detail).length > 0">
                                    <h5 class="text-muted mb-1 text-uppercase"><b>📊 Détail des Leads</b></h5>
                                    <div class="p-3 rounded">
                                        <div v-for="(detail, product, index) in props.row.leads_detail"
                                            :key="product"
                                            class="d-flex justify-content-between align-items-center py-2"
                                            :class="{ 'border-bottom border-secondary': index < Object.keys(props.row.leads_detail).length - 1 }"
                                            style="border-color: rgba(255,255,255,0.1) !important;">
                                            <div class="d-flex align-items-center">
                                                <i :class="getProductIcon(product)" class="mr-3" style="font-size: 1.1rem;"></i>
                                                <span class="text-capitalize text-light font-weight-medium">{{ product }}</span>
                                            </div>
                                            <div class="text-right d-flex justify-content-end align-items-center">
                                                <div class="mx-3">
                                                    <span class="text-white font-weight-bold">{{ detail.count }}</span>
                                                    <span class="text-muted ml-1">leads</span>
                                                </div>
                                                <div class="mx-3">
                                                    <span class="text-info font-weight-bold">{{ detail.total_points }}</span>
                                                    <span class="text-muted ml-1">pts</span>
                                                </div>
                                                <div class="mx-3">
                                                    <span class="text-success font-weight-bold">{{ detail.prix_total.toFixed(2) }}€</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- TABLEAU DES ACTIONS -->
                                <div class="col-md-6" v-if="props.row.actions_detail && Object.keys(props.row.actions_detail).length > 0">
                                    <h5 class="text-muted mb-1 text-uppercase"><b>⚡ Détail des Actions</b></h5>
                                    <div class="p-3 rounded">
                                        <div v-for="(detail, action, index) in props.row.actions_detail"
                                            :key="action"
                                            class="d-flex justify-content-between align-items-center py-2"
                                            :class="{ 'border-bottom border-secondary': index < Object.keys(props.row.actions_detail).length - 1 }"
                                            style="border-color: rgba(255,255,255,0.1) !important;">
                                            <div class="d-flex align-items-center">
                                                <i :class="getActionIcon(action)" class="mr-3" style="font-size: 1.1rem;"></i>
                                                <span class="text-capitalize text-light font-weight-medium">{{ action }}</span>
                                            </div>
                                            <div class="text-right d-flex justify-content-end align-items-center">
                                                <div class="mx-3">
                                                    <span class="text-white font-weight-bold">{{ detail.count }}</span>
                                                    <span class="text-muted ml-1">actions</span>
                                                </div>
                                                <div class="mx-3">
                                                    <span class="text-info font-weight-bold">{{ detail.total_points }}</span>
                                                    <span class="text-muted ml-1">pts</span>
                                                </div>
                                                <div class="mx-3">
                                                    <span class="text-success font-weight-bold">{{ detail.prix_total.toFixed(2) }}€</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Si aucune donnée -->
                                <div v-if="(!props.row.leads_detail || Object.keys(props.row.leads_detail).length === 0) &&
                                        (!props.row.actions_detail || Object.keys(props.row.actions_detail).length === 0)"
                                    class="col-md-12 text-center text-muted py-3">
                                    <i class="tim-icons icon-alert-circle-exc mr-2"></i>
                                    Aucune donnée disponible
                                </div>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <!-- Colonnes spécifiques -->
                <el-table-column label="ID Paraineur" prop="id_paraineur" show-overflow-tooltip sortable ></el-table-column>
                <el-table-column label="Login" prop="login_client" show-overflow-tooltip sortable></el-table-column>
                <el-table-column label='Nbr Leads' prop="nbr_leads_precedent" :sort-method="sortByNbrLeads" sortable>
                    <template scope="scope"><span>{{ scope.row.nbr_leads_precedent }}</span></template>
                </el-table-column>
                <el-table-column label="Date Creation Client" prop="datecreation_client" show-overflow-tooltip sortable >
                    <template scope="scope">{{ custom_date(scope.row.datecreation_client.split(" ")[0]) }}</template>
                </el-table-column>
                <el-table-column label="Points total" prop="points_total" show-overflow-tooltip :sort-method="sortByPoints" sortable>
                </el-table-column>
                <el-table-column label="Points total (€)" show-overflow-tooltip sortable prop="points_euro" :sort-method="sortByPointsPrix">
                    <template scope="scope">
                        <div v-if="isConfigLoading">
                            <i class="fas fa-spinner fa-spin text-muted"></i>
                        </div>
                        <div v-else>
                            {{ (scope.row.points_total_prix).toFixed(2) }} €
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="Points a valider" prop="solde_a_valider" show-overflow-tooltip sortable :sort-method="sortBySoldeAValider">
                    <template scope="scope">{{ scope.row.solde_a_valider }}</template>
                </el-table-column>
                <el-table-column label="Points a valider (€)" prop="solde_a_valider_euro"  show-overflow-tooltip sortable :sort-method="sortBySoldeAValiderPrix">
                    <template scope="scope">{{ ( scope.row.solde_a_valider_prix ).toFixed(2)  }} €</template>
                </el-table-column>
                <el-table-column label="Date MAJ" prop="solde_updated_at" show-overflow-tooltip sortable>
                    <template scope="scope">
                    <p v-if="scope.row.solde_updated_at !== null">{{ custom_date(scope.row.solde_updated_at) }}</p><p v-else>--</p>
                    </template>
                </el-table-column>
                <el-table-column label="Action" align="center">
                    <template scope="scope">
                    <div class="text-center">
                        <base-button
                            @click.native="validerParaineur(scope.row)"
                            class="btn btn-round btn-success mr-2"
                            size="sm"
                            :disabled="scope.row.solde_a_valider<=4000"
                            title="Valider solde"
                        >
                            <i class="tim-icons icon-check-2"></i>
                        </base-button>
                        <base-button
                            @click.native="openModifierPointsModal(scope.row)"
                            class="btn btn-round btn-warning"
                            size="sm"
                            title="Modifier points"
                        ><i class="tim-icons icon-pencil"></i>
                        </base-button>
                    </div>
                    </template>
                </el-table-column>
            </el-table>



            <!-- ================================================================ -->
            <!-- TABLEAU 2 : AFFICHAGE POUR TM (law === 'ma')                       -->
            <!-- ================================================================ -->
            <!-- show-summary :summary-method="getSummaries"  class="customtable_statsCampEdit"-->
            <el-table :key="'table-af'" :data="queriedData" show-summary :summary-method="getSummaries" v-loading="$apollo.queries.getTopCaAnnonceurOrEditeur.loading" @selection-change="handleSelectionChangeEdit" v-else-if="law != 'ma'" class="customtable_cmd">
              <el-table-column
                type="selection"
                width="55">
              </el-table-column>
              <el-table-column
                label="Societe"
                prop="societe_client"
                show-overflow-tooltip
                sortable
                min-width="150"
              ></el-table-column>
              <el-table-column
                label="Login"
                prop="login_client"
                show-overflow-tooltip
                sortable
                min-width="125"
              >
              </el-table-column>
              <el-table-column
                :label="'Ca (' + this.months[this.month2] + ')'"
                prop="ca2"
                show-overflow-tooltip
                sortable
                min-width="100"
              >
                <template scope="scope">
                  {{ formatThounsends(scope.row.ca2, true) + ' €' }}
                </template>
              </el-table-column>
              <el-table-column
                :label="'Ca (' + this.months[this.month] + ')'"
                prop="ca"
                show-overflow-tooltip
                sortable
                min-width="100"
              >
                <template scope="scope">
                  {{ formatThounsends(scope.row.ca, true) + ' €' }}
                </template>
              </el-table-column>
              <el-table-column
                label="Platforme"
                minWidth="150"
              >
                <template scope="scope">
                  <div>
                    <button class="btn btn-link btn-default btn-icon btn-sm like" v-if="scope.row.id_client_myaffile">
                    <svg version="1.1" id="Calque_1" fill="#988fc3" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                      viewBox="0 0 355.2 394.3" style="enable-background:new 0 0 355.2 394.3" xml:space="preserve">
                      <g>
                        <polygon class="st1" points="183.5,95.9 158.8,167.8 135.1,99 121.4,99 150.6,184 167,184 183.5,135.9 193,163.6 199.9,143.6   "/>
                        <path class="st1" d="M177.6,41.6c-53.4,0-96.8,43.4-96.8,96.8c0,39.5,23.7,73.4,57.7,88.5l4.1-12c-29-13.3-49.1-42.6-49.1-76.5
                          c0-46.4,37.8-84.2,84.2-84.2c46.4,0,84.2,37.8,84.2,84.2c0,39.2-26.9,72.2-63.2,81.5l4-11.7L239.7,99h-16.1l-25.2,73.8l-11.7,34.1
                          h0.2l-5.3,15.7l-4.4,12.8c0.1,0,0.3,0,0.4,0c5.5,0,10.9-0.5,16.2-1.4c45.7-7.7,80.6-47.6,80.6-95.5C274.4,85,231,41.6,177.6,41.6z"
                          />
                      </g>
                      <title>WEEDO PERF</title>
                    </svg>
                  </button>
                  <button class="btn btn-link btn-default btn-icon btn-sm like" v-if="scope.row.id_client_mycoreg">
                    <svg version="1.1" id="Calque_1" fill="#54c4d5" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                      viewBox="0 0 355.2 394.3" style="enable-background:new 0 0 355.2 394.3" xml:space="preserve">
                      <g>
                        <polygon class="st1" points="183.5,95.9 158.8,167.8 135.1,99 121.4,99 150.6,184 167,184 183.5,135.9 193,163.6 199.9,143.6   "/>
                        <path class="st1" d="M177.6,41.6c-53.4,0-96.8,43.4-96.8,96.8c0,39.5,23.7,73.4,57.7,88.5l4.1-12c-29-13.3-49.1-42.6-49.1-76.5
                          c0-46.4,37.8-84.2,84.2-84.2c46.4,0,84.2,37.8,84.2,84.2c0,39.2-26.9,72.2-63.2,81.5l4-11.7L239.7,99h-16.1l-25.2,73.8l-11.7,34.1
                          h0.2l-5.3,15.7l-4.4,12.8c0.1,0,0.3,0,0.4,0c5.5,0,10.9-0.5,16.2-1.4c45.7-7.7,80.6-47.6,80.6-95.5C274.4,85,231,41.6,177.6,41.6z"
                          />
                      </g>
                      <title>WEEDO COREG</title>
                    </svg>
                  </button>
                  <button class="btn btn-link btn-default btn-icon btn-sm like" v-if="scope.row.id_client_leadmarket">
                    <svg version="1.1" id="Calque_1" fill="#588bbd" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                      viewBox="0 0 355.2 394.3" style="enable-background:new 0 0 355.2 394.3" xml:space="preserve">
                      <g>
                        <polygon class="st1" points="183.5,95.9 158.8,167.8 135.1,99 121.4,99 150.6,184 167,184 183.5,135.9 193,163.6 199.9,143.6   "/>
                        <path class="st1" d="M177.6,41.6c-53.4,0-96.8,43.4-96.8,96.8c0,39.5,23.7,73.4,57.7,88.5l4.1-12c-29-13.3-49.1-42.6-49.1-76.5
                          c0-46.4,37.8-84.2,84.2-84.2c46.4,0,84.2,37.8,84.2,84.2c0,39.2-26.9,72.2-63.2,81.5l4-11.7L239.7,99h-16.1l-25.2,73.8l-11.7,34.1
                          h0.2l-5.3,15.7l-4.4,12.8c0.1,0,0.3,0,0.4,0c5.5,0,10.9-0.5,16.2-1.4c45.7-7.7,80.6-47.6,80.6-95.5C274.4,85,231,41.6,177.6,41.6z"
                          />
                      </g>
                      <title>WEEDO MARKET</title>
                    </svg>
                  </button>
                  <template v-if="scope.row.client_mongustave">
                    <img src="img/ico-mongustave.png" width="20" height="20" title="MON GUSTAVE"/>
                  </template>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="Date Creation Client"
                prop="datecreation_client"
                show-overflow-tooltip
                sortable
                min-width="150"
              >
              <template scope="scope">
                {{ custom_date(scope.row.datecreation_client.split(" ")[0]) }}
              </template>
              </el-table-column>
              <el-table-column
                label="Solde"
                prop="solde"
                show-overflow-tooltip
                sortable
                min-width="100"
              >
              <template scope="scope">
                {{ scope.row.solde }}
              </template>
              </el-table-column>
              <el-table-column
                label="action"
                show-overflow-tooltip
                min-width="100"
              >
                <template scope="scope">
                    <div>
                        <base-button @click.native="EditItemF(scope.row)" class="btn-link btn-warning" type="success" size="sm"
                            icon>
                            <i class="tim-icons icon-pencil"></i>
                        </base-button>
                    </div>
                </template>
              </el-table-column>
               <el-table-column
                 label="Date Mise à jour"
                prop="solde_updated_at"
                show-overflow-tooltip
                sortable
                min-width="100"
              >
                <template scope="scope">
                  <p v-if="scope.row.solde_updated_at !== null"> {{ custom_date(scope.row.solde_updated_at) }} </p>
                  <p v-else> {{ "--" }} </p>
                </template>
              </el-table-column>
              <div
              slot="footer"
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
              >
            </div>
            </el-table>

            <el-table :key="'table-ma'" :data="queriedData" show-summary :summary-method="getSummaries" v-loading="$apollo.queries.getTopCaAnnonceurOrEditeur.loading" v-else class="customtable_cmd">
              <el-table-column
                type="selection"
                width="55">
              </el-table-column>
              <el-table-column
                label="Societe"
                prop="societe_client"
                show-overflow-tooltip
                sortable
                min-width="150"
              ></el-table-column>
              <el-table-column
                label="Login"
                prop="login_client"
                show-overflow-tooltip
                sortable
                min-width="125"
              >
              </el-table-column>
              <el-table-column
                :label="'Ca (' + this.months[this.month2] + ')'"
                prop="ca"
                show-overflow-tooltip
                sortable
                min-width="100"
              >
                <template scope="scope">
                  {{ formatThounsends(scope.row.ca2, true) + ' €' }}
                </template>
              </el-table-column>
              <el-table-column
                :label="'Ca (' + this.months[this.month] + ')'"
                prop="ca"
                show-overflow-tooltip
                sortable
                min-width="100"
              >
                <template scope="scope">
                  {{ formatThounsends(scope.row.ca, true) + ' €' }}
                </template>
              </el-table-column>
              <el-table-column
                label="Platforme"
                minWidth="150"
              >
                <template scope="scope">
                  <button class="btn btn-link btn-default btn-icon btn-sm like" v-if="scope.row.id_client_myaffile">
                    <svg version="1.1" id="Calque_1" fill="#988fc3" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                      viewBox="0 0 355.2 394.3" style="enable-background:new 0 0 355.2 394.3" xml:space="preserve">
                      <g>
                        <polygon class="st1" points="183.5,95.9 158.8,167.8 135.1,99 121.4,99 150.6,184 167,184 183.5,135.9 193,163.6 199.9,143.6   "/>
                        <path class="st1" d="M177.6,41.6c-53.4,0-96.8,43.4-96.8,96.8c0,39.5,23.7,73.4,57.7,88.5l4.1-12c-29-13.3-49.1-42.6-49.1-76.5
                          c0-46.4,37.8-84.2,84.2-84.2c46.4,0,84.2,37.8,84.2,84.2c0,39.2-26.9,72.2-63.2,81.5l4-11.7L239.7,99h-16.1l-25.2,73.8l-11.7,34.1
                          h0.2l-5.3,15.7l-4.4,12.8c0.1,0,0.3,0,0.4,0c5.5,0,10.9-0.5,16.2-1.4c45.7-7.7,80.6-47.6,80.6-95.5C274.4,85,231,41.6,177.6,41.6z"
                          />
                      </g>
                      <title>WEEDO PERF</title>
                    </svg>
                  </button>
                  <button class="btn btn-link btn-default btn-icon btn-sm like" v-if="scope.row.id_client_mycoreg">
                    <svg version="1.1" id="Calque_1" fill="#54c4d5" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                      viewBox="0 0 355.2 394.3" style="enable-background:new 0 0 355.2 394.3" xml:space="preserve">
                      <g>
                        <polygon class="st1" points="183.5,95.9 158.8,167.8 135.1,99 121.4,99 150.6,184 167,184 183.5,135.9 193,163.6 199.9,143.6   "/>
                        <path class="st1" d="M177.6,41.6c-53.4,0-96.8,43.4-96.8,96.8c0,39.5,23.7,73.4,57.7,88.5l4.1-12c-29-13.3-49.1-42.6-49.1-76.5
                          c0-46.4,37.8-84.2,84.2-84.2c46.4,0,84.2,37.8,84.2,84.2c0,39.2-26.9,72.2-63.2,81.5l4-11.7L239.7,99h-16.1l-25.2,73.8l-11.7,34.1
                          h0.2l-5.3,15.7l-4.4,12.8c0.1,0,0.3,0,0.4,0c5.5,0,10.9-0.5,16.2-1.4c45.7-7.7,80.6-47.6,80.6-95.5C274.4,85,231,41.6,177.6,41.6z"
                          />
                      </g>
                      <title>WEEDO COREG</title>
                    </svg>
                  </button>
                  <button class="btn btn-link btn-default btn-icon btn-sm like" v-if="scope.row.id_client_leadmarket">
                    <svg version="1.1" id="Calque_1" fill="#588bbd" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                      viewBox="0 0 355.2 394.3" style="enable-background:new 0 0 355.2 394.3" xml:space="preserve">
                      <g>
                        <polygon class="st1" points="183.5,95.9 158.8,167.8 135.1,99 121.4,99 150.6,184 167,184 183.5,135.9 193,163.6 199.9,143.6   "/>
                        <path class="st1" d="M177.6,41.6c-53.4,0-96.8,43.4-96.8,96.8c0,39.5,23.7,73.4,57.7,88.5l4.1-12c-29-13.3-49.1-42.6-49.1-76.5
                          c0-46.4,37.8-84.2,84.2-84.2c46.4,0,84.2,37.8,84.2,84.2c0,39.2-26.9,72.2-63.2,81.5l4-11.7L239.7,99h-16.1l-25.2,73.8l-11.7,34.1
                          h0.2l-5.3,15.7l-4.4,12.8c0.1,0,0.3,0,0.4,0c5.5,0,10.9-0.5,16.2-1.4c45.7-7.7,80.6-47.6,80.6-95.5C274.4,85,231,41.6,177.6,41.6z"
                          />
                      </g>
                      <title>WEEDO MARKET</title>
                    </svg>
                  </button>
                  <template v-if="scope.row.client_mongustave">
                    <img src="img/ico-mongustave.png" width="20" height="20" title="MON GUSTAVE"/>
                  </template>
                </template>
              </el-table-column>
              <el-table-column
                label="Date Creation Client"
                prop="datecreation_client"
                show-overflow-tooltip
                sortable
                min-width="150"
              >
              <template scope="scope">
                {{ custom_date(scope.row.datecreation_client.split(" ")[0]) }}
              </template>
              </el-table-column>
              <el-table-column
                label="Solde"
                prop="solde"
                show-overflow-tooltip
                sortable
                min-width="100"
              >
              <template scope="scope">
                {{ scope.row.solde }}
              </template>
              </el-table-column>
              <el-table-column
                label="action"
                show-overflow-tooltip
                min-width="100"
              >
                <template scope="scope">
                    <base-button @click.native="EditItemF(scope.row)" class="btn-link btn-warning" type="success" size="sm"
                      icon>
                      <i class="tim-icons icon-pencil"></i>
                    </base-button>
                </template>
              </el-table-column>
              <el-table-column
                label="Date Mise à jour"
                prop="solde_updated_at"
                show-overflow-tooltip
                sortable
                min-width="100"
              >
                <template scope="scope">
                  <p v-if="scope.row.solde_updated_at !== null"> {{ custom_date(scope.row.solde_updated_at) }} </p>
                  <p v-else> {{ "--" }} </p>
                </template>
              </el-table-column>
              <div
              slot="footer"
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
              >
              </div>
            </el-table>

             <div v-if="law === 'pa'" slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
                <div>
                    <p class="card-category">{{ $t('labels.Datatable.Showing') }} {{ fromPa + 1 }} {{ $t('labels.Datatable.to') }} {{ toPa }} {{ $t('labels.Datatable.of') }} {{ totalPa }} {{ $t('labels.Datatable.entries') }}</p>
                </div>
                <base-pagination
                    class="pagination-no-border"
                    v-model="paginationPa.currentPage"
                    :per-page="paginationPa.perPage"
                    :total="totalPa"
                ></base-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <fab
      v-if='MiltipleRowEdit.length && !$apollo.queries.getTopCaAnnonceurOrEditeur.loading'
      @click.native="EditCadeauF"
      position="bottom-rignt"
      main-tooltip="modifier"
      main-icon="edit"
      icon-size="small"
      bg-color="#004F84"
    ></fab>
    <!-- Modal Edit HMTL VISUEL -->
    <modal_selfEvent :show.sync="ShowEditCadeau" body-classes="p-0" modal-classes="modal-dialog-centered ">
      <card type="secondary" header-classes="pb-5"  class="border-0 mb-0  update-solde-table" style="width: 40vw;">
        <el-tooltip
          content="Quitter"
          effect="light"
          :open-delay="300"
          placement="top"
        >
          <base-button
            @click.native="closepop"
            class="btn-link float-right"
            type="danger"
            size="sm"
            icon
          >
            <i class="tim-icons icon-simple-remove icon-large"></i>
          </base-button>
        </el-tooltip>
        <template v-if="ShowEditCadeau">
         <table class="table">
            <thead>
              <tr>
                <th>SOCIETE</th>
                <th>CA</th>
                <th class="text-center pl-3">POINT ACTUEL</th>
                <th class="text-center pl-3">POINT A AJOUTER</th>
                <th class="text-center pl-3">TOTAL DES POINT</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(edit, i) in MiltipleRowEdit" :key="i">
                <th scope="row" style="color: #fff">
                  {{ edit.societe_client }}
                </th>
                <td style='width: 6.5em;'>{{ formatThounsends(edit.ca, true) }}  € </td>
                <td class="text-center pl-12 ">{{ edit.solde }}</td>
                <td class="text-center pl-12">
                  <span style="color: green"
                    >+{{ calcule_point(edit.ca) }}</span
                  >
                </td>
                <td class="text-center pl-12">
                  {{ edit.solde + calcule_point(edit.ca) }}
                </td>
              </tr>
            </tbody>
          </table>
          <center>
          <base-button
            v-if="update_loader"
            loading
            class="btn btn-round btn-just-icon btn-info mt-0 d-block"
            >{{ $t("buttons.BtnLoad").toUpperCase() }}...</base-button>
            <base-button
              disabled
              class="btn btn-round btn-just-icon btn-info mt-0 d-block"
              v-else-if="update_end"
            >POINTS AJOUTES</base-button>
            <base-button
              class="btn btn-round btn-just-icon btn-info mt-0 d-block"
              @click.native="updatePoints"
              v-else
            >AJOUTER DES POINTS</base-button>
          </center>
        </template>
      </card>
    </modal_selfEvent>
    <!-- Modal Edit HMTL VISUEL -->
    <!-- Modal Edit HMTL VISUEL -->
    <modal_selfEvent :show.sync="ShowItemCadeau" body-classes="p-0" modal-classes="modal-dialog-centered modal-sm">
      <card type="secondary" header-classes="bg-white pb-5" body-classes="px-lg-5 py-lg-5" class="border-0 mb-0">
        <el-tooltip
            content="Quitter"
            effect="light"
            :open-delay="300"
            placement="top"
          >
          <base-button
            @click.native="closepopItem"
            class="btn-link float-right"
            type="danger"
            size="sm"
            icon
          >
            <i class="tim-icons icon-simple-remove icon-large"></i>
          </base-button>
        </el-tooltip>
        <h3 class="card-title">Points : {{ this.globaleSolde}}</h3>
        <template v-if="ShowItemCadeau">
          <form role="form">
            <base-input label="Points À Ajouter :" v-model="soldeEdit">
            </base-input>
            <div class="text-center">
              <base-button type="info" @click="EditSolde" class="my-4">{{ $t("buttons.BtnAdd").toUpperCase() }}</base-button>
            </div>
          </form>
        </template>
      </card>
    </modal_selfEvent>
    <!-- Modal Edit HMTL VISUEL -->
    <!-- Modal Configuration Valeurs Leads -->
    <modal_selfEvent :show.sync="ShowLeadValuesModal" body-classes="p-0" modal-classes="modal-dialog-centered modal-md">
        <card type="secondary" header-classes="bg-white pb-5" body-classes="px-lg-5 py-lg-5" class="border-0 mb-0" style="width: 600px;">
            <el-tooltip
            content="Quitter"
            effect="light"
            :open-delay="300"
            placement="top"
            >
                <base-button
                    @click.native="closeLeadValuesModal"
                    class="btn-link float-right"
                    type="danger"
                    size="sm"
                    icon
                >
                    <i class="tim-icons icon-simple-remove icon-large"></i>
                </base-button>
            </el-tooltip>

            <h3 class="card-title text-uppercase text-white mb-4 font-weight-bold" style="font-size: 1.5rem; letter-spacing: 1px;">Configuration Points</h3>

            <div>
                <!-- 1. ETAT DE CHARGEMENT (AJOUT DE CE BLOC) -->
                <div
                    class="row w-100 d-flex justify-content-center align-items-center p-2"
                    style="height: 200px"
                    v-if="isConfigLoading"
                >
                    <div
                        class="h-100 d-flex justify-content-between align-items-center"
                    >
                        <i class="fas fa-spinner fa-spin fa-2x"></i>
                        <p class="px-2 text-muted mb-0">
                            Chargement en cours...
                        </p>
                    </div>
                </div>
                <!-- AJOUT DE CETTE SECTION POUR L'ERREUR -->
                <div v-else-if="parrainageConfigError">
                    <base-alert type="primary">
                        <span>{{ parrainageConfigError }}</span>
                    </base-alert>
                </div>
                <div v-else>
                        <!-- Section Lead -->
                    <h5 class="text-light text-uppercase font-weight-bold mb-3" style="font-size: 1.1rem; letter-spacing: 0.5px;">
                        <i class="tim-icons icon-single-02 mr-2"></i>Lead
                    </h5>

                    <div v-for="field in leadFields" :key="field.key" class="mb-3">
                        <div class="form-row">
                            <div class="col">
                                <base-input
                                :label="field.label"
                                :name="field.key"
                                v-model.number="tempPointsValues[field.key]"
                                @keypress="($event.charCode >= 48 && $event.charCode <= 57) || $event.preventDefault()"
                                :error="getError(field.key)"
                                 v-validate="'required'"
                                ></base-input>
                            </div>
                        </div>
                    </div>

                    <!-- Section Action -->
                    <hr class="my-4">
                    <h5 class="text-light text-uppercase font-weight-bold mb-3" style="font-size: 1.1rem; letter-spacing: 0.5px;">
                        <i class="tim-icons icon-settings-gear-63 mr-2"></i>Action
                    </h5>

                    <div v-for="field in actionFields" :key="field.key" class="mb-3">
                        <div class="form-row">
                            <div class="col">
                                <base-input
                                :label="field.label"
                                :name="field.key"
                                v-model.number="tempPointsValues[field.key]"
                                @keypress="($event.charCode >= 48 && $event.charCode <= 57) || $event.preventDefault()"
                                :error="getError(field.key)"
                                 v-validate="'required'"
                                ></base-input>
                            </div>
                        </div>
                    </div>
                    <!--btn valider global -->
                    <hr class="my-4">
                    <div class="text-center">
                        <base-button
                            @click="saveAllChanges"
                            type="success"
                            size="lg"
                            :disabled="isSaving"
                            class="btn btn-round btn-info"
                        >
                            <i v-if="!isSaving" class="fas fa-check mr-2"></i>
                            <i v-else class="fas fa-spinner fa-spin mr-2"></i>
                            {{ isSaving ? 'Enregistrement...' : 'Valider' }}
                        </base-button>
                    </div>
                </div>
            </div>
            <!-- end -->
        </card>
    </modal_selfEvent>
    <!-- End Modal Configuration Valeurs Leads -->
    <!-- Modal Modifier Points Parrain -->
    <modal_selfEvent :show.sync="ShowModifierPointsModal" body-classes="p-0" modal-classes="modal-dialog-centered modal-sm">
        <card type="secondary" header-classes="bg-white pb-5" body-classes="px-lg-5 py-lg-5" class="border-0 mb-0">
            <el-tooltip content="Quitter" effect="light" :open-delay="300" placement="top">
                <base-button
                    @click.native="closeModifierPointsModal"
                    class="btn-link float-right"
                    type="danger"
                    size="sm"
                    icon
                >
                    <i class="tim-icons icon-simple-remove icon-large"></i>
                </base-button>
            </el-tooltip>

            <h3 class="card-title text-white">Modifier les Points</h3>
            <p class="text-muted mb-3">Parrain: {{ pointsModificationData.login_client }}</p>

            <template v-if="ShowModifierPointsModal">
                <form role="form">
                    <div class="mb-3">
                        <label class="text-white">Points à valider actuels :</label>
                        <h4 class="text-info">{{ pointsModificationData.points_actuels }} pts</h4>
                    </div>

                    <div class="mb-3">
                        <base-radio
                            inline
                            name="ajouter"
                            class="mb-2"
                            v-model="pointsModificationData.type_modification"
                            value="ajouter"
                        >
                            Ajouter
                        </base-radio>
                        <base-radio
                            inline
                            name="diminuer"
                            class="mb-2"
                            v-model="pointsModificationData.type_modification"
                            value="diminuer"
                        >
                            Diminuer
                        </base-radio>
                    </div>

                    <base-input
                        label="Points à modifier :"
                        v-model.number="pointsModificationData.points_a_modifier"
                        type="number"
                        min="0"
                        placeholder="Entrez le nombre de points"
                    >
                    </base-input>

                    <div class="mb-3 p-3 bg-dark rounded">
                        <label class="text-muted mb-1">Nouveau total :</label>
                        <h4 class="mb-0" :class="nouveauTotalPoints >= 0 ? 'text-success' : 'text-danger'">
                            {{ nouveauTotalPoints }} pts
                        </h4>
                    </div>

                    <div class="text-center">
                        <base-button
                            v-if="updatingPoints"
                            loading
                            class="btn btn-round btn-info my-4"
                        >
                            Modification...
                        </base-button>
                        <base-button
                            v-else
                            type="info"
                            @click="appliquerModificationPoints"
                            class="my-4"
                            :disabled="!pointsModificationData.points_a_modifier || pointsModificationData.points_a_modifier <= 0 || nouveauTotalPoints <= 0"
                        >
                            APPLIQUER
                        </base-button>
                    </div>
                </form>
            </template>
        </card>
    </modal_selfEvent>
<!-- End Modal Modifier Points Parrain -->
  </div>
</template>

<script>
  import { Table, TableColumn, DatePicker, Select, Option } from 'element-ui';
  import { BaseRadio } from 'src/components/index'
  import gql from 'graphql-tag'
  import moment from 'moment'
  import Modal_selfEvent from 'src/components/Modal_selfEvent'
  import fab from 'vue-fab'
  import XLSX from 'xlsx'
  import { BaseAlert } from "src/components";
  import { BasePagination } from "src/components";
  import Swal from 'sweetalert2';

  export default {
    apollo: {
      getTopCaAnnonceurOrEditeur: {
        client: 'AUTH',
        query: gql`
          query($droit: String) {
            getTopCaAnnonceurOrEditeur (droit: $droit){
              societe_client
              login_client
              ca
              ca2
              datecreation_client
              solde
              solde_updated_at
              mois
              annee
              user_id
              droit
              code_client
              solde_created_at
              id_client_myaffile
              id_client_mycoreg
              id_client_leadmarket
              client_mongustave
            }
          }
        `,
        skip() {
          return this.skipQuery
        },
        variables() {
          return {
            droit: this.law,
          };
        },
        result({ data, loader, networkStatus }) {
          this.ListClient = []
          data.getTopCaAnnonceurOrEditeur.forEach(datag => {
            this.ListClient.push({
              user_id: datag.user_id,
              societe_client: datag.societe_client
            })
          });
          console.log(this.ListClient)
          this.skipQuery = true
        },
        fetchPolicy: 'network-only'
      }
    },
    components: {
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [DatePicker.name]: DatePicker,
      [Select.name]: Select,
      [Option.name]: Option,
      BaseRadio,
      fab,
      Modal_selfEvent,
      BaseAlert,
      BasePagination
    },
    data() {
      return {
        init_num:0,
        months:[
          'Janvier',
          'Février',
          'Mars',
          'Avril',
          'Mai',
          'Juin',
          'Juillet',
          'Août',
          'Septembre',
          'Octobre',
          'Novembre',
          'Décembre'
        ],
        MiltipleRowEdit: [],
        fabActions: [
              {
                  name: 'add',
                  icon: 'add',
                  tooltip: 'ajout des points'
              },

        ],
        disableinput: false,
        month: moment().subtract(1,'months').month(),
        month2:moment().subtract(2,'months').month(),
        solde:0,
        soldeEdit:0,
        droitUser:null,
        globaleSolde:0,
        ShowEditCadeau: false,
        ShowItemCadeau: false,
        skipQuery: true,
        total: 0,
        update_loader:false,
        update_end:false,
        getTopCaAnnonceurOrEditeur: [],
        law: 'af',
        ListClient: [],
        societySelected: '',
        ParraineurData: [],
        pointsConfigData: [],
        tempPointsValues: {},
        ShowLeadValuesModal: false,
        parrainageConfigError : null,
        isConfigLoading : null,
        downloadingParrains : false,
        updatingPoints : false,
        ShowModifierPointsModal: false,
        pointsModificationData: {
        id_paraineur: null,
        login_client: '',
        points_actuels: 0,
        points_a_modifier: 0,
        type_modification: 'ajouter' // 'ajouter' ou 'diminuer'
        },
        paginationPa: {
            perPage:10,
            currentPage: 1,
            perPageOptions: [10, 20, 50, 100, 500],
            total: 0
        },
        totalPa: 0,
        isSaving: false,
        email: null,
      }
    },
    computed: {
        queriedData() {
            // Si la vue est "Parraineur"
            if (this.law === 'pa') {
                let filteredData = this.ParraineurData;

                // Si un terme de recherche est saisi, on filtre par login_client
                if (this.societySelected && this.societySelected.trim() !== '') {
                    const searchTerm = this.societySelected.toLowerCase();
                    filteredData = this.ParraineurData.filter(user =>
                        user.login_client.toLowerCase().includes(searchTerm)
                    );
                }

                this.totalPa = filteredData.length;
                return filteredData.slice(this.fromPa, this.toPa)

                // La pagination s'applique sur les données (filtrées ou non)
                //return filteredData.slice(this.from, this.to);
            }

            // Comportement original pour les autres vues (Editeurs, TM, etc.)
            this.total = (this.getTopCaAnnonceurOrEditeur) ? this.getTopCaAnnonceurOrEditeur.length : 0
            return (this.societySelected === '') ? this.getTopCaAnnonceurOrEditeur.slice(this.from, this.to) : this.getTopCaAnnonceurOrEditeur.slice(this.from, this.to).filter(x => x.societe_client === this.societySelected)
        },
        toPa() {
            let highBound = this.fromPa + this.paginationPa.perPage;
            if (this.totalPa < highBound) {
                highBound = this.totalPa;
            }
            return highBound;
        },
        fromPa() {
            return this.paginationPa.perPage * (this.paginationPa.currentPage - 1);
        },
        pointsDefinition() {
                const definition = {};
                this.pointsConfigData.forEach(item => {
                    definition[item.nom] = item.point;
                });
                return definition;
            },
        leadFields() {
            return this.pointsConfigData
                .filter(item => item.type === 'produit')
                .map(item => ({
                    key: item.nom,
                    label: item.label.charAt(0).toUpperCase() + item.label.slice(1),
                    id_point: item.id_point,
                    point: item.point
                }));
        },

        actionFields() {
            return this.pointsConfigData
                .filter(item => item.type === 'action')
                .map(item => ({
                    key: item.nom,
                    label: item.label.charAt(0).toUpperCase() + item.label.slice(1),
                    id_point: item.id_point,
                    point: item.point
                }));
        },
        nouveauTotalPoints() {
            const base = this.pointsModificationData.points_actuels;
            const modification = this.pointsModificationData.points_a_modifier || 0;

            if (this.pointsModificationData.type_modification === 'ajouter') {
                return base + modification;
            } else {
                return base - modification;
            }
        }

    },
    created(){
        this.email = JSON.parse(localStorage.getItem('utilisateur')).email
            let accessToken = localStorage.getItem("token_jwt");
            this.parrainageConfigError = null;
            this.isConfigLoading = true;
            const api_url = "https://api-auth-plf.wee-do-it.net/api/v1"
            //const api_url = "http://127.0.0.1:8000/api/v1"
            this.axios
                    .get(
                        `${api_url}/get-parrainage-points`,
                        {
                            headers: {
                                "Content-Type": "application/json",
                                authorization: `Bearer ${accessToken}`,
                            },
                        }
                    )
                    .then(({ data }) => {
                        this.pointsConfigData = data.result;
                        this.tempPointsValues = { ...this.pointsDefinition };

                    })
                    .catch((error) => {
                        console.log('error', error)
                        this.parrainageConfigError = "Impossible de charger la configuration des points. Veuillez rafraîchir la page et réessayer.";

                    })
                    .finally(() => {
                        // MODIFICATION 2 : Arrêter le chargement dans tous les cas
                        this.isConfigLoading = false;
                    });

    },
    methods: {
      ExportTable() {
        if (this.getTopCaAnnonceurOrEditeur.length) {
          let getTopCaAnnonceurOrEditeur = JSON.parse(JSON.stringify(this.getTopCaAnnonceurOrEditeur));
          getTopCaAnnonceurOrEditeur.forEach(function(data){
            delete data.mois
            delete data.annee
            delete data.user_id
            delete data.droit
            delete data.code_client
            delete data.solde_created_at
            delete data.id_client_myaffile
            delete data.id_client_mycoreg
            delete data.id_client_leadmarket
            delete data.client_mongustave
            delete data.__typename

            data.ca2 = data.ca2.toFixed(2).replace(".", ",")
            data.ca = data.ca.toFixed(2).replace(".", ",")

          });
          const fileName = 'SOLDE_CADEAUX.csv'
          var Stats = XLSX.utils.json_to_sheet(getTopCaAnnonceurOrEditeur)
          Stats = XLSX.utils.sheet_to_csv(Stats, {FS:";"});

          Stats = Stats.replace("societe_client","Societe")
          Stats = Stats.replace("login_client","Login")
          Stats = Stats.replace("ca2","Ca (" + this.months[this.month2] + ")")
          Stats = Stats.replace("ca","Ca (" + this.months[this.month] + ")")
          Stats = Stats.replace("datecreation_client","Date Creation Client")
          Stats = Stats.replace("solde","Solde")
          Stats = Stats.replace("solde_updated_at","Date Mise à jour")

          var blob = new Blob(["\ufeff", Stats]);
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
        }
      },
      custom_date(date){
        return moment(new Date(date)).format("DD-MM-YYYY")
      },
      calcule_point(ca){
        return parseInt(((2*ca)/100) * 8)
      },
      closepop(){
        this.ShowEditCadeau = false
        this.update_end = false
      },
      closepopItem(){
        this.ShowItemCadeau = false
      },
      updatePoints() {
        let selected = [];
        this.update_loader = true;
        let formData = new FormData();
        this.MiltipleRowEdit.forEach(function (item, key) {
          formData.append(`users[${key}][user_id]`, item.user_id);
          formData.append(`users[${key}][ca]`, item.ca);
          formData.append(
            `users[${key}][point]`,
            parseInt(((2 * item.ca) / 100) * 8)
          );
          formData.append(`users[${key}][droit]`, item.droit);
        });
        const url_api =
          "https://api-auth-plf.wee-do-it.net/api/v1/update_sold_cadeaux";

        let accessToken = localStorage.getItem("token_jwt");

        this.axios
          .post(url_api, formData, {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              authorization: `Bearer ${accessToken}`,
            },
          })
          .then((response) => {
            this.$notify({
              type: "success",
              message: "Point ajouté avec succes",
            });
            this.update_loader = false;
            this.update_end = true;
          })
          .catch(() => {
            console.log("error occured");
          });

        for (const m in this.MiltipleRowEdit) {
          for (let i in this.getTopCaAnnonceurOrEditeur) {
            if (
              this.getTopCaAnnonceurOrEditeur[i].user_id ===
              this.MiltipleRowEdit[m].user_id
            ) {
              this.getTopCaAnnonceurOrEditeur[i].solde = parseInt(
                ((2 * this.MiltipleRowEdit[m].ca) / 100) * 8
              );
              break; //Stop this loop, we found it!
            }
          }
        }
      },
      async EditSolde(row) {
        await this.$apollo.mutate({
          client: "AUTH",
          mutation: gql`mutation (
              $solde:Int!
              $user_id: Int!
              $droit: String
            ) {
              set_solde_cadeau
               (
                 solde:$solde,
                 user_id:$user_id
                 droit:$droit
                )
              {
                message
            }
          }`,
          variables: {
            solde: this.soldeEdit,
            user_id: this.user_id,
            droit: this.droitUser,
          },
        }).then(response => {
          let respMutation = response.data.set_solde_cadeau.message
          if(respMutation.includes('erreur')){
            this.ShowItemCadeau = false
            this.$notify({type: 'warning', message:  'erreur serveur'})
          } else {
            this.$notify({
              type: "success",
              message: "Point ajouté avec succes",
            });
            this.ShowItemCadeau = false
            for (var i in this.getTopCaAnnonceurOrEditeur) {
              if (this.getTopCaAnnonceurOrEditeur[i].user_id === this.user_id) {
                  this.getTopCaAnnonceurOrEditeur[i].solde = this.globaleSolde;
                  break; //Stop this loop, we found it!
              }
            }
          }
        }).catch(error => {
          this.ShowItemCadeau = false
          this.$notify({type: 'warning', message: this.$t("apiresponse.restorationerror") })
        })
      },
      async RefreshSolde(row) {
        const result = await this.$apollo.query({
          client: "AUTH",
          query: gql`
          query($user_id: Int!) {
          refreshCompteCadeaux (user_id: $user_id){
            solde
            message
            }
          }
          `,
          variables: {
            user_id: row.user_id,
          },
        }).then(response => {
          let resp = response.data.refreshCompteCadeaux.solde
          for (var i in this.getTopCaAnnonceurOrEditeur) {
            if (this.getTopCaAnnonceurOrEditeur[i].user_id === row.user_id) {
                this.getTopCaAnnonceurOrEditeur[i].solde = resp;
                break; //Stop this loop, we found it!
            }
          }
         this.$notify({type: 'success', verticalAlign: 'top', horizontalAlign: 'right', message: 'Solde actualisé' });
        }).catch(error => {
          this.$notify({type: 'warning', message: this.$t("apiresponse.restorationerror") })
        })
      },
      EditCadeauF(row) {
        this.ShowEditCadeau = true
      },
      EditItemF(row) {
        this.ShowItemCadeau = true
        this.solde = (row.solde !== null) ? row.solde : 0
        this.soldeEdit = 0
        this.globaleSolde = this.solde
        this.user_id = row.user_id
        this.droitUser = row.droit
      },
      getPaSummaries(param) {
        const { columns, data } = param;
        const sums = [];

        let sumNbrLeads = 0;
        let sumPoints = 0;
        let sumPoints_prix = 0;
        let sumSoldeActuel = 0;
        let sumSoldeActuel_prix = 0;

        data.forEach(row => {
            sumNbrLeads += row.nbr_leads_precedent;

            sumPoints += row.points_total;
            sumPoints_prix += row.points_total_prix;

            // Sum 'solde_actuel' for the 'Solde Actuel' column
                sumSoldeActuel += row.solde_a_valider;
                sumSoldeActuel_prix += row.solde_a_valider_prix;
        });
        // Calculate euro sums
        const sumPointsEuro = sumPoints * 0.1;
        const sumSoldeActuelEuro = sumSoldeActuel * 0.1;

        columns.forEach((column, index) => {
          // Initialize sums array with empty strings for non-total columns
          if (index === 0) { // First column, usually empty or a label
            sums[index] = ''; // Or leave empty if preferred
            return;
          }
          else if (column.property === 'nbr_leads_precedent') {
            sums[index] = sumNbrLeads;
          }
          else if (column.property === 'points_total') { // This assumes you add a prop="points" to your Points column for 'pa'
            sums[index] = sumPoints;
          }
          else if (column.property === 'solde_a_valider') {
            sums[index] = sumSoldeActuel;
          }
          else if (column.property === 'points_euro') {
            sums[index] = `${sumPoints_prix.toFixed(2)} €`;
          }
          else if (column.property === 'solde_a_valider_euro') {
            sums[index] = `${sumSoldeActuel_prix.toFixed(2)} €`;
          }
          else {
            sums[index] = '';
          }
        });
        return sums;
      },
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        let sumCa_m1 = 0
        let sumCa_m2 = 0
        let sumSolde = 0
        data.forEach(element => {
          sumCa_m1 += element.ca
          sumCa_m2 += element.ca2
          sumSolde += element.solde
        });
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '';
            return;
          }
          else if( index === 1) {
             sums[index] = '';
            return;
          }
          else if( index === 2) {
             sums[index] = '';
            return;
          }
          else if( index === 3) {
            sums[index] = this.formatThounsends(sumCa_m2,true,0) + ' €';
            return;
          }
          else if( index === 4) {
            sums[index] = this.formatThounsends(sumCa_m1,true,0) + ' €';
            return;
          }
          else if( index === 7) {
            sums[index] = sumSolde;
            return;
          }
          else {
            sums[index] = '';
            return;
          }
        });
        return sums;
      },
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      async send() {
        let validate
        await this.$validator.validateAll().then(isValid => {
          validate = isValid
        })
        if (!validate)
          return
        if(this.law != "pa"){
        this.skipQuery = false
        }else{
             this.downloadingParrains = true;
             await this.fetchParraineurs();
            this.downloadingParrains = false;
        }
      },
      formatThounsends: function(value, fixe = false, number = 0){
        value != null ? value = value : value = 0
        if(fixe){
          value = value.toFixed(number)
        }
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
      },
      handleSelectionChangeEdit(row) {
        console.log(row)
        if (row.length) {
          this.MiltipleRowEdit = row
        }else {
          this.MiltipleRowEdit = []
        }
        console.log(this.MiltipleRowEdit)
      },
      // Ajouter ces méthodes dans methods
      openLeadValuesModal() {
        this.tempPointsValues = { ...this.pointsDefinition };
        this.ShowLeadValuesModal = true;
      },

      closeLeadValuesModal() {
        this.ShowLeadValuesModal = false;
      },
        async saveAllChanges() {
            const isValid = await this.$validator.validateAll();

            if (!isValid) {
                return; // Arrêter si la validation échoue
            }
            this.isSaving = true;

            const api_url = "https://api-auth-plf.wee-do-it.net/api/v1";
            let accessToken = localStorage.getItem("token_jwt");

            // Collecter tous les changements
            const allFields = [...this.leadFields, ...this.actionFields];
            const updates = [];

            for (const field of allFields) {
                const newValue = this.tempPointsValues[field.key];

                // Vérifier si la valeur est valide
                if (newValue !== null && newValue !== undefined && newValue != field.point) {
                    updates.push({
                        id_point: field.id_point,
                        key: field.key,
                        point: newValue
                    });
                }
            }

            if (updates.length === 0) {
                this.$notify({ type: 'warning', message: 'Aucune modification à enregistrer.' });
                this.isSaving = false;
                return;
            }

            // Envoyer toutes les requêtes
            try {
                // Envoyer UN SEUL appel API avec tous les changements
                const response = await this.axios.post(
                    `${api_url}/update-parrainage-point`, // ✅ Nouvelle route (pluriel)
                    { updates: updates }, // ✅ Envoyer tout l'array
                    { headers: { authorization: `Bearer ${accessToken}` } }
                );


                // Mettre à jour les données locales
                response.data.result.forEach(updatedPoint => {
                    const originalItem = this.pointsConfigData.find(p => p.id_point === updatedPoint.id_point);
                    if (originalItem) {
                        originalItem.point = updatedPoint.point;
                    }
                });

                // Recalculer les points totaux
                await this.fetchParraineurs();

                this.$notify({
                    type: 'success',
                    message: `${updates.length} point(s) mis à jour avec succès !`
                });

                // Fermer le modal après succès
                this.closeLeadValuesModal();

            } catch (error) {
                console.error("Erreur lors de la mise à jour des points :", error);
                this.$notify({ type: 'danger', message: 'Une erreur est survenue.' });
            } finally {
                this.isSaving = false;
            }
        },
        getProductIcon(product) {
            switch (product) {
            case 'sante': return 'fas fa-heartbeat'
            case 'mrh':   return 'fas fa-home'
            case 'auto':  return 'fas fa-car'
            case 'emprunteur':   return 'tim-icons icon-bank'
            case 'credit conso':   return 'fas fa-credit-card'
            case 'rappel':   return 'fas fa-phone'
            case 'animaux':   return 'fas fa-paw'
            case 'agenda':     return 'fas fa-calendar-alt'
            case 'devis':      return 'fas fa-file-invoice'
            case 'souscrire':  return 'fas fa-file-signature'
            default:      return 'fas fa-box'
            }
        },
        sortByNbrLeads(a, b) {
            // Récupère la valeur de chaque ligne, avec 0 comme valeur par défaut si elle est nulle ou non définie
            const leadsA = Number(a.nbr_leads_precedent) || 0;
            const leadsB = Number(b.nbr_leads_precedent) || 0;

            // La soustraction effectue un tri numérique correct
            return leadsA - leadsB;
        },
        sortBySoldeActuel(a, b) {
            const soldeA = Number(a.solde_actuel) || 0;
            const soldeB = Number(b.solde_actuel) || 0;
            return soldeA - soldeB;
        },

        sortByPoints(a, b) {
            // Comme la valeur n'est pas une propriété directe, nous devons la recalculer ici.
            const pointsA = Number(a.points_total) || 0;
            const pointsB = Number(b.points_total) || 0;
            return pointsA - pointsB;
        },
        sortByPointsPrix(a, b) {
            // Comme la valeur n'est pas une propriété directe, nous devons la recalculer ici.
            const pointsA = Number(a.points_total_prix) || 0;
            const pointsB = Number(b.points_total_prix) || 0;
            return pointsA - pointsB;
        },
        sortBySoldeAValider(a, b) {
            // Comme la valeur n'est pas une propriété directe, nous devons la recalculer ici.
            const pointsA = Number(a.solde_a_valider) || 0;
            const pointsB = Number(b.solde_a_valider) || 0;
            return pointsA - pointsB;
        },
        sortBySoldeAValiderPrix(a, b) {
            // Comme la valeur n'est pas une propriété directe, nous devons la recalculer ici.
            const pointsA = Number(a.solde_a_valider_prix) || 0;
            const pointsB = Number(b.solde_a_valider_prix) || 0;
            return pointsA - pointsB;
        },
        async fetchParraineurs() {
            this.updatingPoints = true;
            let accessToken = localStorage.getItem("token_jwt");

            //const api_url = "http://127.0.0.1:8000/api";
            const api_url = "https://apileadmarket.wee-do-it.net/api";

            try {
                const { data } = await this.axios.get(
                    `${api_url}/get_all_parrains`,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            authorization: `Bearer ${accessToken}`,
                        },
                    }
                );

                this.ParraineurData = data.data.parraineurs.map(item => {
                const parrain = item.parrain;
                const points = item.points;

                // Séparer leads_detail et actions_detail
                const leads_detail = {};
                const actions_detail = {};

                // LEADS uniquement
                if (points.details.leads.details) {
                    points.details.leads.details.forEach(lead => {
                        const produitKey = lead.produit.toLowerCase();
                        if (!leads_detail[produitKey]) {
                            leads_detail[produitKey] = {
                                count: 0,
                                val_lead: lead.points_unitaire,
                                total_points: 0,
                                prix_total: 0
                            };
                        }
                        leads_detail[produitKey].count += 1;
                        leads_detail[produitKey].total_points += lead.total_points;
                        leads_detail[produitKey].prix_total += lead.prix;
                    });
                }

                // ACTIONS uniquement
                if (points.details.actions.details) {
                    points.details.actions.details.forEach(action => {
                        const actionKey = action.action_type.toLowerCase();
                        if (!actions_detail[actionKey]) {
                            actions_detail[actionKey] = {
                                count: 0,
                                val_lead: action.points_unitaire,
                                total_points: 0,
                                prix_total: 0
                            };
                        }
                        actions_detail[actionKey].count += action.count;
                        actions_detail[actionKey].total_points += action.total_points;
                        actions_detail[actionKey].prix_total += action.total_points / 100;
                    });
                }

                return {
                    id_paraineur: parrain.id,
                    is_validated: false,
                    login_client: parrain.email,
                    ca: 0,
                    ca2: 0,
                    nbr_leads_precedent: points.summary.unique_leads,
                    leads_detail: leads_detail,
                    actions_detail: actions_detail,  // NOUVEAU
                    datecreation_client: parrain.created_at,
                    solde_a_valider: points.points_a_valider,
                    solde_a_valider_prix: points.prix_points_a_valider,
                    solde_to_add: 0,
                    points_total: points.summary.total_points,
                    points_total_prix: points.summary.prix_total_general,
                    solde_updated_at: parrain.updated_at,
                    user_id: parrain.id
                };
            });
            } catch (error) {
                console.error('Erreur lors de la récupération des parraineurs:', error);
                this.$notify({
                    type: 'danger',
                    message: 'Erreur lors du chargement des données parraineurs'
                });
                this.ParraineurData = [];
            } finally {
                this.updatingPoints = false;
            }
        },
        async validerParaineur(data){
            let result = await Swal.fire({
                text: "Vous êtes sur le point de valider les points de ce membre. Voulez-vous continuer ?",
                width: 400,
                showCancelButton: true,
                confirmButtonColor: '#988fc3',
                cancelButtonColor: '#27293D',
                confirmButtonText: 'Valider',
                cancelButtonText: 'Annuler'
            })
            if (result.value) {
                await this.updateParrainPoints(
                    data.user_id,
                    data.solde_a_valider,
                    "Parrain validé avec succès"
                );
            }

        },
        async updateParrainPoints(userId, pointsToAdd, successMessage) {
            this.updatingPoints = true;

            try {
                let accessToken = localStorage.getItem("token_jwt");
                const api_url = "https://apileadmarket.wee-do-it.net/api";

                const response = await this.axios.post(
                    `${api_url}/add_pr_points`,
                    {
                        user_id: userId,
                        points_to_add: pointsToAdd,
                        droit: 'PARRAIN'
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            authorization: `Bearer ${accessToken}`,
                        },
                    }
                );

                await this.fetchParraineurs();

                this.$notify({
                    type: "success",
                    message: successMessage,
                });

            } catch (error) {
                console.error('Erreur lors de la mise à jour des points:', error);
                this.$notify({
                    type: "danger",
                    message: "Erreur lors de la mise à jour des points"
                });
            } finally {
                this.updatingPoints = false;
            }
        },
        getActionIcon(action) {
            const icons = {
                'devis': 'tim-icons icon-paper',
                'subscription': 'tim-icons icon-check-2',
                'rappel': 'tim-icons icon-mobile',
                'agenda': 'tim-icons icon-calendar-60'
            };
            return icons[action] || 'tim-icons icon-bullet-list-67 text-muted';
        },
      openModifierPointsModal(row) {
            this.pointsModificationData = {
                id_paraineur: row.id_paraineur,
                user_id: row.user_id,
                login_client: row.login_client,
                points_actuels: row.solde_a_valider,
                points_a_modifier: 0,
                type_modification: 'ajouter'
            };
            this.ShowModifierPointsModal = true;
        },

        closeModifierPointsModal() {
            this.ShowModifierPointsModal = false;
            this.pointsModificationData = {
                id_paraineur: null,
                login_client: '',
                points_actuels: 0,
                points_a_modifier: 0,
                type_modification: 'ajouter'
            };
        },

    async appliquerModificationPoints() {
        const montantModification = this.nouveauTotalPoints
        await this.updateParrainPoints(
            this.pointsModificationData.user_id,
            montantModification,
            `Points ${this.pointsModificationData.type_modification === 'ajouter' ? 'ajoutés' : 'diminués'} avec succès`
        );

        this.closeModifierPointsModal();
        }
    },
    watch : {
      soldeEdit(value){
        let v = 0;
        if(value !== ""){
          v = value
        }
        this.globaleSolde = parseInt(this.solde) + parseInt(v)
      },
      societySelected(value){
        console.log('selected value is / ',value)
      },
      law() {
        this.societySelected = '';
        if(this.MiltipleRowEdit.length > 0){
          this.MiltipleRowEdit = []
        }
        this.getTopCaAnnonceurOrEditeur = [];
      },
      'pointsModificationData.type_modification'(newValue) {
        this.pointsModificationData.points_a_modifier = 0;
    }
    }
  }
</script>

<style>
  .update-solde-table
  {
    max-height: 500px;
    display: block;
    overflow-y:scroll;
  }
  .booking-table-rows {
    text-transform: uppercase;
  }
  .modal-content {
    background-color: transparent;
  }
  .modal.show .modal-dialog {
    transform: translate(0, 0%);
  }
  /* .customtable_statsCampEdit .cell{
    word-break: break-word;
    font-size: 11.5px;
  } */
  .el-table__row .form-control {
    background-color: transparent;
  }
  .customtable_cmd .cell{
    word-break: break-word;
  }
</style>
